(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const OFFSET = 120;

  // 🔥 Core scroll function
  function scrollToHash(hash) {
    if (!hash) return;

    const id = hash.replace('#', '');
    const el = document.getElementById(id);
    if (!el) return;

    const elementPosition = el.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - OFFSET;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }

  // ✅ On page load (with hash)
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
      scrollToHash(window.location.hash);
    }, 300);
  });

  // ✅ On hash change (fallback)
  window.addEventListener('hashchange', () => {
    scrollToHash(window.location.hash);
  });

  // ✅ On Shopify section reload (AJAX pagination)
  document.addEventListener('shopify:section:load', () => {
    setTimeout(() => {
      scrollToHash(window.location.hash);
    }, 300);
  });

  // 🔥 KEY FIX: Handle pagination clicks (numbers + arrows)
  document.addEventListener('click', function (e) {
    const link = e.target.closest('.pagination__link');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href || !href.includes('#')) return;

    const hash = '#' + href.split('#')[1];

    // Wait for page / AJAX render
    setTimeout(() => {
      scrollToHash(hash);
    }, 300);
  });

  } catch(e) { console.error(e); }
})();
})();
